/* Stuti Weaves — Festive 2026 · Night on the Ghats · small interactions */
(function () {
  'use strict';
  var d = document, w = window, body = d.body;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header height -> CSS var (hero overlap, sticky offsets) */
  function measureHeader() {
    var h = d.querySelector('.site-header-wrapper');
    if (!h) return;
    var hh = Math.round(h.getBoundingClientRect().height) || 0;
    if (hh > 0) d.documentElement.style.setProperty('--fs-header-h', hh + 'px');
  }
  measureHeader();
  w.addEventListener('resize', measureHeader);
  w.addEventListener('load', measureHeader);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(measureHeader);

  /* Scrolled state (solid header after the hero's first screen) */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    w.requestAnimationFrame(function () {
      body.classList.toggle('fs-scrolled', w.scrollY > 36);
      ticking = false;
    });
  }
  onScroll();
  w.addEventListener('scroll', onScroll, { passive: true });

  /* Reveal on scroll */
  var items = d.querySelectorAll('.fs-reveal');
  if (!items.length || reduce || !('IntersectionObserver' in w)) {
    items.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    /* Horizontal rails: reveal every card once the rail itself is in view */
    d.querySelectorAll('.fs-edit__grid').forEach(function (rail) {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { rail.querySelectorAll('.fs-reveal').forEach(function (c) { c.classList.add('is-in'); }); ro.disconnect(); }
        });
      }, { threshold: 0.05 });
      ro.observe(rail);
    });
    /* Anything already in view on load should never wait */
    setTimeout(function () {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < w.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 120);
  }

  /* Hero: keep the first-screen CTAs clear of the floating WhatsApp button (app embed, fixed position) */
  (function () {
    var hero = d.querySelector('.fs-hero'); if (!hero) return;
    var copy = hero.querySelector('.fs-hero__copy'), actions = hero.querySelector('.fs-hero__actions');
    if (!copy || !actions) return;
    function clear() {
      hero.style.removeProperty('--fs-wa-lift');
      if (w.innerWidth < 901) return;
      var btn = d.querySelector('.wa__btn_popup') || d.querySelector('#whatsAppWidgetSpan .wa__button');
      if (!btn) return;
      var b = btn.getBoundingClientRect(); if (!b.width || !b.height) return;
      var a = actions.getBoundingClientRect();
      var at = a.top + w.scrollY, ab = a.bottom + w.scrollY; /* where the CTAs sit on the first screen */
      var x = a.left < b.right + 16 && a.right > b.left - 16;
      var y = ab > b.top - 14 && at < b.bottom + 14;
      if (x && y) {
        var pad = parseFloat(getComputedStyle(copy).paddingBottom) || 0;
        hero.style.setProperty('--fs-wa-lift', Math.ceil(pad + (ab - (b.top - 14))) + 'px');
      }
    }
    [0, 800, 2000, 4000, 7000].forEach(function (t) { setTimeout(clear, t); });
    w.addEventListener('resize', clear);
    if ('MutationObserver' in w) {
      var mo = new MutationObserver(function () { if (d.querySelector('.wa__btn_popup')) { clear(); setTimeout(clear, 400); mo.disconnect(); } });
      mo.observe(d.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
  })();

  /* Announcement rotation */
  d.querySelectorAll('[data-fs-announcement]').forEach(function (root) {
    var slides = root.querySelectorAll('.fs-announcement__item');
    if (slides.length < 2) return;
    var i = 0, every = parseInt(root.getAttribute('data-every') || '5', 10) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      setTimeout(function () {
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 380);
    }, every);
  });

  /* Signature weaves: hover switches the stage image */
  d.querySelectorAll('[data-fs-weaves]').forEach(function (root) {
    var links = root.querySelectorAll('[data-weave]');
    var imgs = root.querySelectorAll('[data-weave-img]');
    var cap = root.querySelector('[data-weave-cap]');
    function show(key, label) {
      imgs.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-weave-img') === key); });
      if (cap && label) cap.textContent = label;
    }
    links.forEach(function (a) {
      var fn = function () { show(a.getAttribute('data-weave'), a.getAttribute('data-weave-label')); };
      a.addEventListener('mouseenter', fn);
      a.addEventListener('focus', fn);
    });
  });

  /* Courtesy code: copy to clipboard */
  d.querySelectorAll('[data-fs-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-fs-copy');
      var label = btn.querySelector('.cp');
      var done = function () { if (label) { var t = label.textContent; label.textContent = 'Copied'; setTimeout(function () { label.textContent = t; }, 1800); } };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else { done(); }
    });
  });

  /* Hero video: play only when visible, respect reduced motion */
  d.querySelectorAll('video[data-fs-autoplay]').forEach(function (v) {
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    if (!('IntersectionObserver' in w)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { v.play && v.play().catch(function(){}); } else { v.pause(); } });
    }, { threshold: 0.2 }).observe(v);
  });
})();
